import { render, staticRenderFns } from "./SurveyQuestionsSection.vue?vue&type=template&id=a63ccce8"
import script from "./SurveyQuestionsSection.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports